import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Role} from '@nxt/model-core';
import {UserListDialog} from '../../../nxto/src/app/_components/users/user-list.dialog';
import {PageService} from '@library/shared/_services/page.service';
import {CommonModule} from '@angular/common';
import {AvatarStackComponent} from '@library/shared/avatars/avatar.stack.component';
import {Subscription, take} from 'rxjs';
import {FireService} from '@library/nxt/_services/fire.service';
import {OnDestroyPage} from '@library/shared/_inherited/ondestroy.page';
import {IconsComponent} from '@library/shared/icons/icons.component';

@Component({
    standalone: true,
    imports: [CommonModule, AvatarStackComponent, IconsComponent],
    selector: 'followers',
    template: `
        <div class="flex w-full" *ngIf="parent && parent[property]">
            <div class="flex-none inline" *ngIf="label && !removeOnly && !iconOnly">
                <button (click)="edit();" [class]="btnClass" [disabled]="removeOnly">
                    {{ label }}
                    <span *ngIf="!avatars" class="ml-1">{{ parent[property].length }}</span>
                </button>
            </div>

            <button
                *ngIf="iconOnly && !removeOnly"
                (click)="edit();"
                [class]="btnClass"
                [disabled]="removeOnly"
                [title]="label"
                class="flex-none mt-0.5"
            >
                <icon [name]="getIconName()" class="h-4 w-4"></icon>
            </button>

            <div class="flex place-content-center" *ngIf="avatars">
                <avatar-stack
                    (onClick)="$event ? remove($event) : edit()"
                    [size]="size"
                    [btnClass]="btnClass"
                    [limit]="limit"
                    [items]="parent[property]"
                    [debug]="debug"
                    [editable]="!removeOnly"
                ></avatar-stack>
            </div>
        </div>
    `
})
export class FollowersComponent extends OnDestroyPage implements OnChanges {
    @Output() onChange: EventEmitter<any[]> = new EventEmitter<any[]>();
    @Input() label: string = 'Followers';
    @Input() parent: any;
    @Input() property: string = 'followers';
    @Input() limit: number = 3;
    @Input() size: number = 6;
    @Input() avatars: boolean = true;
    @Input() btnClass: string = 'btn-gray btn-xs';
    @Input() roles: Role[];
    @Input() removeOnly: boolean = false;
    @Input() debug: boolean;
    @Input() iconOnly: boolean = false;
    sub: Subscription;

    constructor(
        private pSvc: PageService,
        private fSvc: FireService
    ) {
        super();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.parent && changes.parent) {
            if (!this.parent[this.property]) {
                this.parent[this.property] = [];
            }
            this.watchParent();
        }
    }

    watchParent() {
        if (this.parent?._exists) {
            this.sub?.unsubscribe();
            this.sub = this.fSvc.watchObject(this.parent._docRef.path, this.d$)
                .subscribe(([obj,delta]) => {
                    this.parent = obj;
                });
        }
    }

    async remove(item: any) {
        try {
            this.parent.remove(this.property, item);
            this.onChange.emit(this.parent[this.property]);
        } catch (e) {
            console.warn(e);
        }
    }

    edit() {
        this.pSvc.modal$.next({
            component: UserListDialog,
            label: this.label,
            onLoaded: (comp: UserListDialog) => {
                comp.parent = this.parent;
                comp.property = this.property;
                comp.roles = this.roles;
                comp.ngOnChanges();
                comp.onClose.pipe(take(1)).subscribe(
                    users => {
                        this.onChange.emit(users);
                    }
                );
            }
        });
    }

    getIconName(): string {
        if (this.property === 'agents') return 'heroicon-outline-user';
        if (this.property === 'followers') return 'heroicon-outline-user-group';
        return 'heroicon-outline-users';
    }
}
